import { render, staticRenderFns } from "./SidebarItems.vue?vue&type=template&id=39a1cafc&scoped=true&"
import script from "./SidebarItems.vue?vue&type=script&lang=js&"
export * from "./SidebarItems.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItems.vue?vue&type=style&index=0&id=39a1cafc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a1cafc",
  null
  
)

export default component.exports